// extracted by mini-css-extract-plugin
export default {"editButton":"closingPayrollmonth_editButton__nQeDY","TableBody":"closingPayrollmonth_TableBody__-G3yf","StopButton":"closingPayrollmonth_StopButton__Pawk9"};